import request from '../utils/request';

export function quota(data) {
  return request({
    url: '/api/quota',
    method: 'post',
    data,
  });
}

// 识别图片
export function imgOcr(data) {
  return request({
    url: '/api/pix2text',
    header: {
      'content-type': 'multipart/form-data',
    },
    method: 'post',
    data,
  });
}

// 识别图片
export function imgOcrGpu(data) {
  return request({
    url: '/api-gpu/pix2text',
    header: {
      'content-type': 'multipart/form-data',
    },
    method: 'post',
    data,
  });
}

// 获取任务结果
export function getTaskResult(data) {
  return request({
    url: '/api/result/' + data.task_id,
    method: 'get',
    params: {
      session_id: data.session_id,
    }
  });
}


// 获取任务结果
export function getTaskResultGpu(data) {
  return request({
    url: '/api-gpu/result/' + data.task_id,
    method: 'get',
    params: {
      session_id: data.session_id,
    }
  });
}

// 上传结果
export function submitEditResult(data) {
  return request({
    url: '/api/submit_edit_result',
    method: 'post',
    data,
  });
}

export function sendCode(data) {
  return request({
    url: '/api/send_mail_code',
    method: 'post',
    data,
  });
}

export function register(data) {
  return request({
    url: '/api/register',
    method: 'post',
    data,
  });
}

export function login(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data,
  });
}

export function updatePassword(data) {
  return request({
    url: '/api/update_password',
    method: 'post',
    data,
  });
}


export function googleLoginApi(data) {
  return request({
    url: '/api/google_login',
    method: 'post',
    data,
  });
}

// 下载结果
export function exportResult(taskId, params) {
  return request({
    url: `/api/result/${taskId}/export`,
    method: 'get',
    params,
    responseType: 'blob'
  });
}


export function exportResultGpu(taskId, params) {
  return request({
    url: `/api-gpu/result/${taskId}/export`,
    method: 'get',
    params,
    responseType: 'blob'
  });
}

// API Key management
export function getApiKeys(data) {
  return request({
    url: '/api/api_keys',
    method: 'get',
    params: data,
  });
}

export function createApiKey(data) {
  return request({
    url: '/api/api_keys',
    method: 'post',
    data,
  });
}

export function deleteApiKey(data) {
  return request({
    url: `/api/api_keys/${data.key_id}`,
    method: 'delete',
    params: {
      session_id: data.session_id,
    },
  });
}
